import { useState, useEffect } from 'react'
import { Box, Grid, CardHeader, Divider, Fab, CircularProgress } from '@mui/material'
import { useNavigate } from "react-router-dom"
import axios from 'axios'
import Swal from 'sweetalert2'
import Icon from '../../../components/icon'
import MsiDatagridDynamic from '../../../components/custom/MsiDatagridDynamic'
import apiUrl from '../../../configs/constant'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const [listData, setListData] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    useEffect(() => { getData() }, [])

    const getData = () => {
        setListData([])
        Swal.fire({ title: 'Now loading', allowEscapeKey: false, allowOutsideClick: false, didOpen: () => Swal.showLoading() })
        axios.get(apiUrl.apiUrl + '/mm/harga-barang/list', { headers: { Authorization: `Bearer ${token}` } })
            .then(res => {
                if (res.data.success) {
                    setListData(res.data.data)
                    Swal.close()
                } else {
                    Swal.fire({ title: 'Pemberitahuan', text: res.data.message, icon: 'error' })
                }
            })
    }

    const handleEdit = (row: any) => navigate('/mm/harga-barang/detail/' + row.id)

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({ title: 'Now loading', allowEscapeKey: false, allowOutsideClick: false, didOpen: () => Swal.showLoading() })
                axios.delete(apiUrl.apiUrl + '/mm/harga-barang/delete/' + row.id, { headers: { Authorization: `Bearer ${token}` } })
                    .then(res => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: res.data.message,
                            icon: res.data.success ? 'success' : 'error',
                            timer: res.data.success ? 1000 : undefined,
                            timerProgressBar: res.data.success,
                            willClose: res.data.success ? getData : undefined
                        })
                    })
                    .catch(err => Swal.fire({ title: 'Pemberitahuan', text: err.message, icon: 'error' }))
            }
        })
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <div className='content-block dx-card'>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <CardHeader title='MASTER HARGA BARANG' />
                        <Fab color='primary' size='medium' onClick={() => navigate('/mm/harga-barang/add')}>
                            <Icon icon='mdi:plus' fontSize={35} color='white' />
                        </Fab>
                    </Box>
                    <Divider />
                    {loading ? (
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
                            <CircularProgress disableShrink sx={{ mt: 6, height: '100%' }} />
                        </Grid>
                    ) : (
                        <MsiDatagridDynamic key={1} data={listData} title='MASTER HARGA BARANG' onEditRow={handleEdit} onDeleteRow={handleDelete} />
                    )}
                </div>
            </Grid>
        </Grid>
    )
}